"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dist = require("api-fetcher-treeline/dist");

var _util = require("../util");

var Store =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Store, _React$Component);

  function Store() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Store);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Store)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initialState", {
      input: '',
      selectedId: null,
      options: [],
      isLoadingOptions: false,
      didFetchOptionsOnce: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.initialState);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchOptionsDelay", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchOptionsApiRequest", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStore", function (state) {
      return {
        state: state,
        onChange: function onChange(nextInput) {
          return _this.onChange(nextInput);
        },
        onSelect: function onSelect(selectedId) {
          return _this.onSelect(selectedId);
        },
        getSelectedOption: function getSelectedOption() {
          return _this.getSelectedOption();
        },
        resetAutocompleteState: function resetAutocompleteState() {
          return _this.resetAutocompleteState();
        }
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedOption", function () {
      var selectedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedId;
      var options = _this.state.options;
      var optionIdName = _this.props.optionIdName;

      for (var i = 0; i < options.length; i++) {
        var idVal = _this.getOptionIdAsString(options[i][optionIdName]);

        if (idVal === selectedId) {
          return options[i];
        }
      }

      return {};
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelect", function (selectedId) {
      _this.setState(function (state) {
        var nextInput = state.input;

        if (state.selectedId !== selectedId && selectedId) {
          var selected = _this.getSelectedState(selectedId);

          nextInput = selected.selectedDisplayName;
        }

        if (typeof _this.props.onSelectHook === 'function' && selectedId) {
          _this.props.onSelectHook(_this.getSelectedState(selectedId));
        }

        return (0, _objectSpread2.default)({}, state, {
          selectedId: selectedId,
          input: nextInput
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedState", function (selectedId) {
      var nameKey = _this.props.optionDisplayNameKey;

      var selectedOption = _this.getSelectedOption(selectedId);

      return {
        selectedId: selectedId,
        selectedOption: selectedOption,
        selectedDisplayName: selectedOption[nameKey]
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (nextInput) {
      _this.setState(function (state) {
        if (!nextInput) {
          return _this.initialState;
        }

        var selectedId = state.selectedId,
            input = state.input;
        var isNextShorter = nextInput.length < input.length;

        if (selectedId && isNextShorter && _this.fetchOptionsApiRequest) {
          _this.fetchOptionsApiRequest.cancel();

          _this.fetchOptionsApiRequest = null;
        }

        if (typeof _this.props.onChangeHook === 'function') {
          _this.props.onChangeHook(state, nextInput);
        }

        return (0, _objectSpread2.default)({}, state, {
          input: nextInput
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchOptionsForAutocompleteField", function () {
      _this.cancelAnyPendingAutocompleteOptionsRequest();

      _this.registerFetchOptionsApiRequest();

      _this.setState({
        isLoadingOptions: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOptionsResponse", function (optionsResponse) {
      var options = optionsResponse;

      if (typeof _this.props.handleOptionsResponse === 'function') {
        options = _this.props.handleOptionsResponse(optionsResponse);
      }

      _this.setState({
        options: options,
        isLoadingOptions: false,
        didFetchOptionsOnce: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Store, [{
    key: "render",
    value: function render() {
      return this.props.children(this.getStore(this.state));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.fetchOptionsByUserInput(prevState);
      this.clearStateOnResetOverride(prevProps);
      this.resetSelectedIdOnZeroOptionsReceivedFromApi(prevState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelAnyPendingDelay();
      this.cancelAnyPendingAutocompleteOptionsRequest();
    }
  }, {
    key: "resetSelectedIdOnZeroOptionsReceivedFromApi",
    value: function resetSelectedIdOnZeroOptionsReceivedFromApi(prevState) {
      var prevOptionsLen = prevState.options.length;
      var thisOptionsLen = this.state.options.length;
      var hasZeroOptionsNow = thisOptionsLen === 0;
      var userDidSelect = this.state.selectedId !== null;

      if (userDidSelect && prevOptionsLen > 0 && hasZeroOptionsNow) {
        this.setState({
          selectedId: null
        });
      }
    }
  }, {
    key: "cancelAnyPendingAutocompleteOptionsRequest",
    value: function cancelAnyPendingAutocompleteOptionsRequest() {
      if (this.fetchOptionsApiRequest && this.fetchOptionsApiRequest.cancel) {
        this.fetchOptionsApiRequest.cancel();
      }
    }
  }, {
    key: "cancelAnyPendingDelay",
    value: function cancelAnyPendingDelay() {
      if (this.fetchOptionsDelay && this.fetchOptionsDelay.cancel) {
        this.fetchOptionsDelay.cancel();
      }
    }
  }, {
    key: "resetAutocompleteState",
    value: function resetAutocompleteState() {
      if (typeof this.props.onResetState === 'function') {
        this.props.onResetState();
      }

      this.setState(this.initialState);
    }
  }, {
    key: "fetchOptionsByUserInput",
    value: function fetchOptionsByUserInput(prevState) {
      if (this.shouldFetchNewAutocompleteOptions(prevState)) {
        this.registerFetchOptionsTimer();
      }
    }
  }, {
    key: "shouldFetchNewAutocompleteOptions",
    value: function shouldFetchNewAutocompleteOptions(prevState) {
      var prevLen = prevState.input.length;
      var thisLen = this.state.input.length;
      var thisSelected = this.state.selectedId;
      var prevSelected = prevState.selectedId;
      var diff = thisLen - prevLen;
      var hasSameSelected = thisSelected === prevSelected;
      var minChars = this.props.minCharsRequired;
      var hasMoreInput = thisLen >= minChars && diff > 0;
      return hasMoreInput && hasSameSelected;
    }
  }, {
    key: "clearStateOnResetOverride",
    value: function clearStateOnResetOverride(prevProps) {
      var prevResetFlag = prevProps.shouldResetInternalState;
      var thisResetFlag = this.props.shouldResetInternalState;

      if (thisResetFlag && !prevResetFlag) {
        this.resetAutocompleteState();
      }
    }
  }, {
    key: "getOptionIdAsString",
    value: function getOptionIdAsString(optionId) {
      if (typeof optionId === 'string') {
        return optionId;
      }

      return optionId.toString();
    }
  }, {
    key: "registerFetchOptionsTimer",
    value: function registerFetchOptionsTimer() {
      var apiCallDelay = this.props.apiCallDelay;
      this.cancelAnyPendingDelay();
      this.fetchOptionsDelay = (0, _util.cancelableDelay)(apiCallDelay);
      this.fetchOptionsDelay.promise.then(this.fetchOptionsForAutocompleteField).catch(function () {
        return console.log('Canceled');
      });
    }
  }, {
    key: "registerFetchOptionsApiRequest",
    value: function registerFetchOptionsApiRequest() {
      this.fetchOptionsApiRequest = this.getNewFetchOptionsApiRequest();
      this.fetchOptionsApiRequest.promise.then(this.handleOptionsResponse);
    }
  }, {
    key: "getNewFetchOptionsApiRequest",
    value: function getNewFetchOptionsApiRequest() {
      var _this$props = this.props,
          getURLForOptions = _this$props.getURLForOptions,
          fetchRequestOptions = _this$props.fetchRequestOptions;
      var api = new _dist.ApiFetcher(getURLForOptions(this.state.input.trim()));

      if (fetchRequestOptions && (0, _typeof2.default)(fetchRequestOptions) === 'object') {
        api.setFetchOptions(fetchRequestOptions);
      }

      return api.cancelableGet();
    }
  }]);
  return Store;
}(_react.default.Component);

exports.default = Store;
Store.propTypes = {
  onResetState: _propTypes.default.func.isRequired,
  children: _propTypes.default.func.isRequired,
  minCharsRequired: _propTypes.default.number,
  shouldResetInternalState: _propTypes.default.bool,
  optionIdName: _propTypes.default.string.isRequired,
  handleOptionsResponse: _propTypes.default.func,
  onSelectHook: _propTypes.default.func,
  onChangeHook: _propTypes.default.func,
  optionDisplayNameKey: _propTypes.default.string.isRequired,
  apiCallDelay: _propTypes.default.number,
  getURLForOptions: _propTypes.default.func.isRequired,
  fetchRequestOptions: _propTypes.default.object
};